import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, Injector } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';

// eslint-disable-next-line no-restricted-imports
import { IdtFragmentsLayoutPipe } from 'cms/cms-shared/pipes/fragmentsLayout.pipe';
import { setInjector } from 'shared/app.injector';
import { SwiperDirective } from 'shared/directives/swiper.directive';
import { DynamicIdtComponentResolutionPipe } from 'shared/dynamic/dynamic-idt-component-resolution.pipe';
import { DynamicIdtComponentService } from 'shared/dynamic/dynamic-idt-component.service';
import { EmbedVideoService } from 'shared/embed-video/embed-video.service';
import { IdtCapitalizePipe } from 'shared/pipes/capitalize.pipe';
import { IsCurrentPriceOnSalePipe } from 'shared/pipes/current-price-on-sale.pipe';
import { IdtExtractUnitPipe, IdtExtractUnitWithDefaultPipe } from 'shared/pipes/extract-unit.pipe';
import { IdtHtmlFalse } from 'shared/pipes/html-false.pipe';
import { IsDefinedPipe } from 'shared/pipes/is-defined.pipe';
import { IdtParsePipe } from 'shared/pipes/parse.pipe';
import { IdtRoundPipe } from 'shared/pipes/round.pipe';
import { IdtStripHtmlTagsPipe } from 'shared/pipes/strip-html-tags.pipe';
import { IdtStripNonNumericPipe, IdtStripNonNumericWithDefaultPipe } from 'shared/pipes/strip-non-numeric.pipe';
import { IdtTrustHtmlPipe } from 'shared/pipes/trust-html.pipe';
import { LinksService } from 'shared/services/links.service';
import { SegmentationService } from 'shared/services/segmentation.service';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IdtCapitalizePipe,
    IdtRoundPipe,
    IdtTrustHtmlPipe,
    IdtStripHtmlTagsPipe,
    IdtParsePipe,
    IdtFragmentsLayoutPipe,
    IdtHtmlFalse,
    DynamicIdtComponentResolutionPipe,
    IdtStripNonNumericPipe,
    IdtStripNonNumericWithDefaultPipe,
    IdtExtractUnitPipe,
    IdtExtractUnitWithDefaultPipe,
    IsDefinedPipe,
    IsCurrentPriceOnSalePipe,
    SwiperDirective
  ],
  declarations: [
    IdtCapitalizePipe,
    IdtRoundPipe,
    IdtTrustHtmlPipe,
    IdtStripHtmlTagsPipe,
    IdtParsePipe,
    IdtFragmentsLayoutPipe,
    IdtHtmlFalse,
    DynamicIdtComponentResolutionPipe,
    IdtStripNonNumericPipe,
    IdtStripNonNumericWithDefaultPipe,
    IdtExtractUnitPipe,
    IdtExtractUnitWithDefaultPipe,
    IsDefinedPipe,
    IsCurrentPriceOnSalePipe,
    SwiperDirective
  ],
  providers: [
    DynamicIdtComponentService,
    EmbedVideoService,
    LinksService,
    SegmentationService,
    Title,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class SharedModule {

  constructor(injector: Injector) {
    setInjector(injector);
  }

}
